import { FDAutoCompleteInput } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';

const AutoCompleteInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    multiple,
    onBlur,
    onChange,
    onFocus,
    options,
    placeholder,
    readonly,
    required,
    labelPlacement,
    size,
    value,
    ...rest
  } = props;

  return (
    <FDAutoCompleteInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      multiple={multiple}
      onBlur={onBlur}
      onChange={(val) => (val === undefined ? onChange('') : onChange(val))}
      onFocus={onFocus}
      options={options}
      placeholder={placeholder}
      labelPlacement={labelPlacement}
      required={required}
      size={size}
      value={value === '' ? undefined : value}
    />
  );
};

AutoCompleteInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  readonly: inputDefaultProps.readonly,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  multiple: inputDefaultProps.multiple,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  placeholder: inputDefaultProps.placeholder,
  required: inputDefaultProps.required,
};

AutoCompleteInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  error: inputPropTypes.error,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  fullWidth: inputPropTypes.fullWidth,
  helperTextValue: inputPropTypes.helperTextValue,
  label: inputPropTypes.label,
  multiple: inputPropTypes.multiple,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  options: inputPropTypes.options.isRequired,
  placeholder: inputPropTypes.placeholder,
  labelPlacement: inputPropTypes.labelPlacement,
  readonly: inputPropTypes.readonly,
  required: inputPropTypes.required,
  size: inputPropTypes.size.isRequired,
  value: inputPropTypes.value.isRequired,
};

const AutoCompleteInputSmall = (props) => {
  return <AutoCompleteInput {...props} size="sm" />;
};

const AutoCompleteInputLarge = (props) => {
  return <AutoCompleteInput {...props} size="lg" />;
};

export { AutoCompleteInputSmall, AutoCompleteInputLarge };
